const PriorAttainmentLevelInfo = ({ value }) => {
  switch (value) {
    case "01":
      return (
        <p>
          Examples: GCSE (less than 5 at grades A-C); 1 AS Level; Level 1
          Award/Certificate/Diploma; NVQ Level 1; GNVQ Foundation
        </p>
      );

    case "02":
      return (
        <p>
          Examples: GCSE (5 or more, grade A*-C); 2 or 3 AS Levels; BTEC First
          Diploma; NVQ Level 2; GNVQ Intermediate
        </p>
      );

    case "03":
      return (
        <p>
          Examples: A Level (2 or more, grades A*-E); 4 or more AS Levels; BTEC
          National Diploma; NVQ Level 3; GNVQ Advanced
        </p>
      );

    case "09":
      return (
        <p>
          Examples: QCF Award/Certificate at Entry Level; Certificate in Adult
          Literacy, Numeracy, ESOL at Entry Level
        </p>
      );

    case "10":
      return (
        <p>
          Examples: Higher Education, First Degree, HNC, NVQ Level 4, RSA
          Advanced, RSA Higher, Teaching Qualification
        </p>
      );

    case "11":
      return (
        <p>
          Examples: Foundation Degree, HND, NVQ Level 5, other high level
          professional qualification
        </p>
      );

    case "12":
      return <p>Examples: Bachelor's Degree; Graduate Certificate/Diploma</p>;

    case "13":
      return (
        <p>
          Examples: Doctorate; Masters Degree; Postgraduate Certificate/Diploma
        </p>
      );

    default:
      return null;
  }
};

export default PriorAttainmentLevelInfo;
